<template>
  <div>
    <div class="vue-outage-history-wrap">
      <div class="form-container">
        <div
        class="chart-component"
        v-bind:class="{isMobile: isMobile() || isTablet()}">
          <span
          class="error-container"
          v-if="dateRangeValidation && dateRangeValidation.error">
            <span class="error">{{dateRangeValidation.error}}</span>
          </span>
          <div class="chart-container">
            <div
            class="header-container"
            v-bind:class="{noData: outageHistoryApiError, loading: (!chartData.series || !chartData.series.length)}">
              <div
              v-if="chartData.series && chartData.series.length"
              class="date-pickers-container">
                  <span class="date-picker-container">
                    <label>Start Date:</label>
                    <div class="date-picker-wrapper">
                        <v-date-picker
                        @dayclick="onStartDateChange"
                        v-model="datePickerStartDate" />
                    </div>
                  </span>
                  <span class="date-picker-container">
                    <label>End Date:</label>
                    <div class="date-picker-wrapper">
                        <v-date-picker
                        @dayclick="onEndDateChange"
                        v-model="datePickerEndDate"
                        :popover="vDatePickerConfig"/>
                    </div>
                  </span>
              </div>
              <div
              class="radio-buttons-container-groups"
              v-if="chartData.series && chartData.series.length && !outageHistoryApiError">
                <div class="radio-buttons-container">
                  <label>All Utilities</label>
                  <input v-bind:checked="aggregateChartData" type="radio" name="aggregateChartData" value="1" v-on:change="onAggregateChartDataChange($event)">
                  <label>Select Utilities</label>
                  <input v-bind:checked="!aggregateChartData" type="radio" name="aggregateChartData" value="0" v-on:change="onAggregateChartDataChange($event)">
                </div>
                <div class="radio-buttons-container">
                  <label>Events</label>
                  <input v-bind:checked="showTotalEvents" type="radio" name="showTotalEvents" value="1" v-on:change="onYAxisChange($event)">
                  <label>Customers Affected</label>
                  <input v-bind:checked="!showTotalEvents" type="radio" name="showTotalEvents" value="0" v-on:change="onYAxisChange($event)">
                </div>
              </div>
            </div>
            <div class="chart">
              <b-spinner v-if="(!chartData.series || !chartData.series.length) && !outageHistoryApiError" class="ajax-spinner"></b-spinner>
              <div class="outage-history-api-error" v-if="outageHistoryApiError">{{outageHistoryApiError}}</div>
              <div class="chart-title" v-if="chartData.series && chartData.series.length">
                <h3 v-if="aggregateChartData && showTotalEvents">Events: All Utilities</h3>
                <h3 v-if="aggregateChartData && !showTotalEvents">Customers Affected: All Utilities</h3>
                <h3 v-if="!aggregateChartData && showTotalEvents">Events by Utility</h3>
                <h3 v-if="!aggregateChartData && !showTotalEvents">Customers Affected by Utility</h3>
                <h4 v-if="startDateFormatted && endDateFormatted"><strong>From:</strong> {{startDateFormatted}} <strong>to:</strong> {{endDateFormatted}}</h4>
              </div>
              <zingchart v-if="chartData.series && chartData.series.length" :data="chartData"></zingchart>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as _ from 'lodash';
import API from "@/services/api";
import zingchartVue from 'zingchart-vue';
import vueMqMixin from "../mixins/VueMqMixin";

const BODY_HTML_SELECTOR = 'body';
const ONE_HOUR_AS_MILLISECONDS = 3600000;
const CHART_DATE_FORMAT = 'M/DD - h:mm a';
const API_DATE_FORMAT_NO_TIME ='YYYY-MM-DD';
const API_DATE_FORMAT_WITH_TIME ='YYYY-MM-DDThh:mm';
const API_DATE_FORMAT_LAST_MINUTE_OF_DAY ='T23:59';
const API_DATE_FORMAT_FIRST_MINUTE_OF_DAY ='T00:00';
const API_DATE_FORMAT_WITH_TIME_END_OF_HOUR ='YYYY-MM-DDTHH:59';
const OUTAGE_HISTORY_BODY_CLASS = 'outage-history-component-visible';

export default {
  name: "OutageHistory",
  mixins: [vueMqMixin],
  props: {
    user: Object
  },
  data() {
    return {
      userGroups: [],
      endDate: undefined,
      endDateForApi: undefined,
      startDate: undefined,
      startDateForApi: undefined,
      dateRangeValidation: undefined,
      datePickerStartDate: undefined,
      datePickerEndDate: undefined,
      endDateFormatted: undefined,
      startDateFormatted: undefined,
      showTotalEvents: false,
      aggregateChartData: true,
      incidentsSnapshot: undefined,
      outageHistoryApiError: undefined,
      vDatePickerConfig: {
        placement: 'top-end',
      },
      chartData: {
          type: 'line',
          plot: {
            "tooltip-text": "%t customers affected: %v<br>%k",
            highlight: true,
            maxTrackers: 4320,
            shadow: 0,
            marker: {
              type: 'line',
              size: 2
            },
            'line-width': '2px',
            'highlight-state': {
              'line-width': 3
            }
          },
          plotarea: {
              marginLeft:'dynamic',
              marginRight:'dynamic',
              marginBottom:'dynamic'
          },
          legend: undefined,
          series: undefined,
          'scale-x': {
            values: [],
            item: {
                angle: -90,
                fontSize: 9
            },
            transform: {
              type: 'date',
              all: '%M %d - %h:%i %A'
            },
          },
          'scale-y': {
            label: {
              text:'Events',
            }
          }
      }
    };
  },
  beforeDestroy() {
   document.querySelector(BODY_HTML_SELECTOR).classList.remove(OUTAGE_HISTORY_BODY_CLASS);
  },
  async created() {
    this.getUserGroups();
    this.setStartAndEndDates();
    this.getOutagesHistory();
    document.querySelector(BODY_HTML_SELECTOR).classList.add(OUTAGE_HISTORY_BODY_CLASS);
  },
  components: {
    zingchart: zingchartVue
  },
  methods: {
    addTimezoneOffset(targetDate) {
      return (new Date(targetDate || new Date()).getTimezoneOffset()) * 60 * 1000;
    },
    getUserGroups() {
      if (this.user
        && this.user.signInUserSession
        && this.user.signInUserSession.accessToken) {
        const userGroups = this.user.signInUserSession.accessToken.payload["cognito:groups"];
        this.userGroups = userGroups && userGroups.length ? userGroups : this.userGroups;
      }
    },
    resetChart() {
      this.chartData['scale-x'].values = [];
      this.chartData.series = undefined;
    },
    onAggregateChartDataChange(event) {
      this.resetChart();
      this.aggregateChartData = parseInt(event.target.value, 10) ? true : false;
      this.renderChart(this.incidentsSnapshot);
    },
    onYAxisChange(event) {
      this.resetChart();
      this.showTotalEvents = parseInt(event.target.value, 10) ? true : false;
      const yAxisLabel = this.showTotalEvents ? 'Events:' : 'Customers Affected:';
      const dataLabel = this.showTotalEvents ? 'events:' : 'customers affected:';
      this.chartData.plot['tooltip-text'] = `%t ${dataLabel} %v<br>%k`;
      this.chartData['scale-y'].label.text = yAxisLabel;
      this.renderChart(this.incidentsSnapshot);
    },
    validateDateRange(startDate, endDate) {
      if (startDate.getTime() > endDate.getTime()) {
        return {error: 'Start date must be in the past'};
      }

      const days15 = 15 * 24 * 60 * 60 * 1000;

      if((endDate.getTime() - startDate.getTime()) > days15) {
        return {error: 'Date range cannot exceed 15 days'};
      }

      return undefined;
    },
    getChartLegend() {
      return {
        header: {
          text: 'Utility'
        },
        minimize:false,
        draggable:true,
        overflow: 'scroll',
        align: 'right',
        'max-items': 5,
        'highlight-plot':true,
        "vertical-align": 'top'
      }
    },
    getOutagesHistory() {
      this.incidentsSnapshot = undefined;
      this.outageHistoryApiError = undefined;

      try {
        API.GetOutagesHistory(this.startDateForApi, this.endDateForApi).then(jsonData => {
          // update the ui with api data
          this.incidentsSnapshot = jsonData;

          // ensure that the emd date in modal reflect actual last incident dates from api
          this.endDateFormatted = moment(jsonData[jsonData.length - 1].timeStamp).format(CHART_DATE_FORMAT);

          // render the chart
          this.renderChart(jsonData);
        }, err => {
          if (err && err.response && err.response.data && err.response.data.message) {
            this.outageHistoryApiError = err.response.data.message;
          } else {
            this.outageHistoryApiError = 'There was an error loading outage history data';
          }
        })
      } catch (err) {
        console.log(`getOutagesHistory -> catch -> ${err}`);
      }
    },
    setStartAndEndDates() {
      const daysKey = 'days';

      // START DATE
      // set api default start date to midnight two days ago
      const start = new Date();
      start.setHours(0,0,0,0);
      const dateAdjusted = new Date(moment(new Date(start).getTime() + this.addTimezoneOffset()));
      this.startDate = `${moment(new Date()).subtract(2, daysKey).format(API_DATE_FORMAT_NO_TIME)}${API_DATE_FORMAT_FIRST_MINUTE_OF_DAY}`;
      this.startDateForApi = `${moment(new Date(dateAdjusted)).subtract(2, daysKey).format(API_DATE_FORMAT_WITH_TIME)}`;

      // set the date-picker start date
      this.startDateFormatted = moment(this.startDate).format(CHART_DATE_FORMAT);
      this.datePickerStartDate = new Date(this.startDate);

      // END DATE
      // set api end date to 11:59 pm today
      this.endDate = `${moment(new Date()).format(API_DATE_FORMAT_NO_TIME)}${API_DATE_FORMAT_LAST_MINUTE_OF_DAY}`;
      this.endDateForApi = this.endDate;

      // set the date-picker end date
      this.endDateFormatted  = moment(this.endDate).format(CHART_DATE_FORMAT);
      this.datePickerEndDate = new Date(this.endDate);
    },
    onStartDateChange(event) {
      this.dateRangeValidation = undefined;
      this.startDate = `${moment(new Date(event.date)).format(API_DATE_FORMAT_NO_TIME)}${API_DATE_FORMAT_FIRST_MINUTE_OF_DAY}`;

      // ensure that the API call uses UTC time (not local)
      let dateAdjusted = new Date(event.date).getTime() + this.addTimezoneOffset(event.date);

      // we need to determine if the event date & adjusted dates
      // span the moment when daylight savings kicks-in
      const eventDateIsDST = moment(event.date).isDST();
      const dateAdjustedIsDST = moment(dateAdjusted).isDST();

      // if daylight savings terminates after adding timezone offset
      if (eventDateIsDST && !dateAdjustedIsDST) {
        // add an hour
        dateAdjusted = new Date(dateAdjusted).getTime() + ONE_HOUR_AS_MILLISECONDS;
      } else if (!eventDateIsDST && dateAdjustedIsDST) {
        // if daylight savings kicks-in after adding timezone offset
        // subtract an hour
        dateAdjusted = new Date(dateAdjusted).getTime() - ONE_HOUR_AS_MILLISECONDS;
      }

      // format that start date for the API Call (use UTC time)
      this.startDateForApi = `${moment(new Date(dateAdjusted)).format(API_DATE_FORMAT_WITH_TIME)}`;

      this.startDateFormatted = moment(this.startDate).format(CHART_DATE_FORMAT);
      this.dateRangeValidation = this.validateDateRange(new Date(this.startDate), new Date(this.endDate));
      if (this.dateRangeValidation && this.dateRangeValidation.error){return;}
      this.datePickerStartDate = new Date(this.startDate);
      this.resetChart();
      this.getOutagesHistory();
    },
    onEndDateChange(event) {
      this.dateRangeValidation = undefined;
      this.endDate = `${moment(new Date(event.date)).format(API_DATE_FORMAT_NO_TIME)}${API_DATE_FORMAT_LAST_MINUTE_OF_DAY}`;
      const endOfDay = moment(new Date(event.date)).endOf('day');

      // ensure that the API call uses UTC time (not local)
      let endOfDayAdjusted = moment(new Date(endOfDay).getTime() + this.addTimezoneOffset(event.date)).format(API_DATE_FORMAT_WITH_TIME_END_OF_HOUR);

      // we need to determine if the event date & adjusted dates
      // span the moment when daylight savings kicks-in
      const eventDateIsDST = moment(event.date).isDST();
      const endOfDayAdjustedIsDST = moment(endOfDayAdjusted).isDST();

      // if daylight savings terminates after adding timezone offset
      if (eventDateIsDST && !endOfDayAdjustedIsDST) {
        // add an hour
        endOfDayAdjusted = moment(new Date(endOfDayAdjusted).getTime() + ONE_HOUR_AS_MILLISECONDS).format(API_DATE_FORMAT_WITH_TIME_END_OF_HOUR);
      } else if (!eventDateIsDST && endOfDayAdjustedIsDST) {
        // if daylight savings kicks-in after adding timezone offset
        // subtract an hour
        endOfDayAdjusted = moment(new Date(endOfDayAdjusted).getTime() - ONE_HOUR_AS_MILLISECONDS).format(API_DATE_FORMAT_WITH_TIME_END_OF_HOUR);
      }

      // format that start date for the API Call (use UTC time)
      this.endDateForApi = endOfDayAdjusted;

      this.endDateFormatted = moment(endOfDay).format(CHART_DATE_FORMAT);
      this.validateDateRange(new Date(this.startDate), new Date(this.endDate));
      this.dateRangeValidation = this.validateDateRange(new Date(this.startDate), new Date(this.endDate));
      if (this.dateRangeValidation && this.dateRangeValidation.error){return;}
      this.datePickerEndDate = new Date(this.endDate);
      this.resetChart();
      this.getOutagesHistory();
    },
    renderChart(incidentsSnapshot) {
      setTimeout(() => {
        if (this.aggregateChartData) {
          this.renderChartAggregated(incidentsSnapshot);
        } else {
          this.renderChartByUtility(incidentsSnapshot);
        }
        this.chartData.legend = this.aggregateChartData ? undefined : this.getChartLegend();
      }, 25);
    },
    renderChartAggregated(outageHistoryData) {
      // re-set chart
      this.chartData.series = [{text: 'Total', values: []}];

      // set the chart line color
      this.chartData.plot['line-color'] = '#FD9303';

      // set the y-axis title
      const yAxis = this.showTotalEvents ? 'eventCount' : 'customerCount';

      // const values = [];
      const uniqueDates = {};

      // populate uniqueDates with a series of timestamps
      _.forEach(outageHistoryData, (outageHistoryRow) => {
        const ohr = outageHistoryRow;
        const timeStamp = ohr.timeStamp;

        if (!uniqueDates[timeStamp]) {
          uniqueDates[timeStamp] = (yAxis === 'eventCount') ? ohr.eventCount : ohr.customerCount;
        } else {
          uniqueDates[timeStamp] += (yAxis === 'eventCount') ? ohr.eventCount : ohr.customerCount;
        }
      });

      // right now, uniqueDates is an object
      // but, there is no guarantee of property order when iterating
      // this causes the chart to render incorrectly
      // so, we need to put uniqueDates into an array: uniqueDatesSorted
      let uniqueDatesSorted = [];
      for (const uniqueDate in uniqueDates) {
        uniqueDatesSorted.push({key: uniqueDate, val: uniqueDates[uniqueDate]});
      }

      // now, sort the uniqueDatesSorted array
      uniqueDatesSorted.sort((a, b) => new Date(a.key).getTime() - new Date(b.key).getTime());

      // iterate over uniqueDatesSorted and build out this.chartData.series[0].values
      uniqueDatesSorted.forEach(element => {
        this.chartData.series[0].values.push([
          moment(element.key).format(CHART_DATE_FORMAT),
          element.val
        ]);
      });
    },
    renderChartByUtility(outageHistoryData) {
      // re-set chart
      this.chartData.series = [];

      const chartDataSeries = this.chartData.series;
      const userHasGroups = this.userGroups && this.userGroups.length;
      const defaultVisibilty = userHasGroups ? false : true;
      const chartDataScaleXValues = this.chartData['scale-x'].values;

      // let ZingChartVue set the chart line color dynamically
      this.chartData.plot['line-color'] = undefined;

      // set the y-axis title
      const yAxis = this.showTotalEvents ? 'eventCount' : 'customerCount';

      // 1 - build the x-axis chart column names

      // container for a map of unique timestamps for the chart's x-axis
      const datesForChart = {};

      // 1-A - iterate over the outageHistoryData
      _.forEach(outageHistoryData, (outageHistoryRow) => {
        // skip any duplicates
        if (datesForChart[outageHistoryRow.timeStamp]) {return;}

        // mark this datesForChart property
        datesForChart[outageHistoryRow.timeStamp] = true;

        // add this value to this.chartData['scale-x'].values
        chartDataScaleXValues.push(outageHistoryRow.timeStamp);
      });

      // 1-B - sort chartDataScaleXValues
      chartDataScaleXValues.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

      // 1-C - create a temporary array so that we can
      // format the timestamps with moment -> CHART_DATE_FORMAT
      const chartDataScaleXValues_TEMP = [];

      // iterate over chartDataScaleXValues and put them all in chartDataScaleXValues_TEMP
      // but in the right date format
      _.forEach(chartDataScaleXValues, chartDataScaleXValue => {
        chartDataScaleXValues_TEMP.push(moment(chartDataScaleXValue).format(CHART_DATE_FORMAT));
      });

      // 1-D - overwrite chartData['scale-x'].values with chartDataScaleXValues_TEMP
      this.chartData['scale-x'].values = chartDataScaleXValues_TEMP;

      // 2 - build a map of unique utility names
      const utilities = {};

      // iterate over the outageHistoryData
      _.forEach(outageHistoryData, outageHistoryRow => {
        // add this utility to the map
        utilities[outageHistoryRow.utilityName] = utilities[outageHistoryRow.utilityName] || {};
      });

      // 3 - build the x-axis chart column series data

      // iterate over the outageHistoryData
      _.forEach(outageHistoryData, outageHistoryRow => {
        // set the utility in our unique list to have this timestamp
        utilities[outageHistoryRow.utilityName][outageHistoryRow.timeStamp] = {};
      });

      // iterate over our unique list of utilities
      for (let utility in utilities){
        // create an object to add to the x-axis series
        const data = {text: utility, values: [], visible: defaultVisibilty};

        // if there is a user and it is in one or more groups
        if (userHasGroups) {
          // only show this data point if it matches one of the user's groups
          const matchingUtilityName = _.find(this.userGroups, group => { return group === utility.toLowerCase().replace(/\s/.g, ''); });
          if (matchingUtilityName) {data.visible = true;}
        }

        // iterate over the outageHistoryData
        _.forEach(outageHistoryData, (outageHistoryRow) => {
            // only process this utility
            if (outageHistoryRow.utilityName !== utility){return; }

            // format the date
            const incidentDate = moment(outageHistoryRow.timeStamp).format(CHART_DATE_FORMAT);
            // add this timestamp to the data object's series
            data.values.push([incidentDate, outageHistoryRow[yAxis]]);
        });

        // set the chart data x-axis series to this summed data
        chartDataSeries.push(data);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.vue-outage-history-wrap{
  min-height: 500px;

  .chart-component{
    position: relative;

    .error-container{
      position: absolute;
      top: -25px;
      right: 0;
      z-index: 1;

      .error{
        font-weight: $xbold;
        color: $red;
      }
    }

    .chart-container{
      position: relative;
      margin-top: 20px;

      .chart-title{
        h3{
          margin: 20px 0;
          text-align: center;
          font-weight: bold;
        }

        h4 {
          margin: 20px 0;
          text-align: center;
          font-size: 18px;
        }
      }

      .chart{
        .ajax-spinner{
          position: absolute;
          top: 80px;
          left: 40%;
          height: 150px;
          width: 150px;
          color: #fbd850
        }

        .outage-history-api-error{
          font-weight: bold;
          color: #800000;
          font-size: 24px;
          text-align: center;
        }
      }

      .header-container{
        position: relative;
        padding: 10px;
        background-color: $lightGrey;

        &.loading{
          display: none;
        }

        &.noData{
          background-color: #fff;
        }

        .date-pickers-container{
          display: flex;
          margin: 0 0 20px 0;

          .date-picker-container{
            flex: 50%;
            text-align: center;

            label {
              margin-right: 10px;
              font-weight: $xbold;
              font-size: 16px;
            }

            .date-picker-wrapper{
              display: inline-block;
              width: 200px;
            }
          }
        }

        .radio-buttons-container-groups{
          display: flex;
          height: 25px;
          line-height: 25px;

          .radio-buttons-container{
            flex: 50%;
            text-align: center;

            label{
              font-weight: bold;
              color: #333;
              font-size: 16px;
            }

            input[type=radio]{
              margin: 0 10px;
              position: relative;
              top: 3px;
              left: 0;
              color: #fff;
            }
          }
        }

        h2 {
          color: #333;
          font-weight: bold;
          font-size: 22px;
        }
      }
    }

    &.isMobile{
      .chart-container{
        .chart{
          .ajax-spinner{
            position: static;
            display: block;
            height: 150px;
            width: 150px;
            top: 150px;
            margin: 0 auto;
            text-align: center;
          }
        }

        .header-container{
          .date-pickers-container{
            .date-picker-container{
              label {
                display: block;
                margin: 0;
              }
              .date-picker-wrapper{
                display: inline-block;
                width: 150px;
              }
            }
          }

          .radio-buttons-container-groups{
            display: block;
            height: auto;
            line-height: 30px;

            .radio-buttons-container{
              flex: none;

              label{
                font-weight: bold;
                color: #333;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}
</style>